<div class="frame-in">
    <div id="game-container" class="phaser-3"></div>
</div>
